/* tslint:disable */
/* eslint-disable */
/**
 * mindd-patient-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Patient } from '../model';
// @ts-ignore
import type { PatientCreateRequest } from '../model';
// @ts-ignore
import type { PatientPage } from '../model';
// @ts-ignore
import type { PatientSearchRequest } from '../model';
// @ts-ignore
import type { PatientTokens } from '../model';
// @ts-ignore
import type { PatientTokensRequest } from '../model';
// @ts-ignore
import type { PatientUpdateRequest } from '../model';
/**
 * PatientControllerApi - axios parameter creator
 * @export
 */
export const PatientControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Patient ID에 해당하는 환자를 soft delete 처리합니다.
         * @summary Patient 삭제
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('_delete', 'patientId', patientId)
            const localVarPath = `/api/v1/patients/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary QR Code 를 통한 환자 생성, 토큰 없음
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromBody: async (code: string, patientCreateRequest: PatientCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('createFromBody', 'code', code)
            // verify required parameter 'patientCreateRequest' is not null or undefined
            assertParamExists('createFromBody', 'patientCreateRequest', patientCreateRequest)
            const localVarPath = `/api/v1/patients/body`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환자 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 같은 기관 내에 동일한 환자 코드 또는 전화번호가 이미 존재하는지 확인합니다. code 또는 phoneNumber 중 하나 이상이 필요합니다.
         * @summary Patient 중복 검사
         * @param {string} [code] 
         * @param {string} [phoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exist: async (code?: string, phoneNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/exist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patient 다건 조회
         * @param {Array<string>} [ids] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll1: async (ids?: Array<string>, orgIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (orgIds) {
                localVarQueryParameter['orgIds'] = orgIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patient ID로 환자 한 명의 상세 정보를 조회합니다.
         * @summary Patient 단건 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('findById', 'patientId', patientId)
            const localVarPath = `/api/v1/patients/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자 대면 자격(동의 요청·설문 세션·수면일지·신원 토큰)으로 자기 정보를 조회합니다. 삭제된 환자는 404 입니다. 이 경로는 자격이 가리키는 환자를 돌려주므로, 환자를 가리키지 않는 자격(서버 간 호출·업무 사용자)은 인가 거부가 아니라 잘못된 요청(400)입니다.
         * @summary 특정 병원의 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 병원 환자 목록 조회
         * @param {string} [searchKeyword] 검색 키워드. null 이면 전체를 반환. 키워드가 있다면 이름과 전화번호에서 검색
         * @param {number} [pageSize] 
         * @param {string} [pageTargetPatientId] null인 경우 가장 최근 부터, 아닌 경우 patientId 이후 부터 검색
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPages: async (searchKeyword?: string, pageSize?: number, pageTargetPatientId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchKeyword !== undefined) {
                localVarQueryParameter['searchKeyword'] = searchKeyword;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageTargetPatientId !== undefined) {
                localVarQueryParameter['pageTargetPatientId'] = pageTargetPatientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자에게 알림톡 링크로 전달할 신원 토큰을 발행합니다. 수신 서비스(audience)는 지정한 값이 그대로 실리며, 비어 있거나 빈 문자열 원소가 섞이면 400 입니다. 만료(expiresAt)를 생략하면 만료 없는 토큰이 나가고, 이미 지난 시각이면 400 입니다. 없거나 삭제된 환자는 실패시키지 않고 skipped 로 돌려줍니다.
         * @summary 환자 신원 토큰 발행(1건도 목록으로)
         * @param {PatientTokensRequest} patientTokensRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuePatientTokens: async (patientTokensRequest: PatientTokensRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientTokensRequest' is not null or undefined
            assertParamExists('issuePatientTokens', 'patientTokensRequest', patientTokensRequest)
            const localVarPath = `/api/v1/patients/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientTokensRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 조회 조건을 본문으로 받습니다. 삭제된 환자는 결과에서 빠지고, 없는 ID 는 건너뜁니다.
         * @summary Patient 다건 조회(조건을 본문으로, 삭제된 환자 제외)
         * @param {PatientSearchRequest} patientSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPatients: async (patientSearchRequest: PatientSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSearchRequest' is not null or undefined
            assertParamExists('searchPatients', 'patientSearchRequest', patientSearchRequest)
            const localVarPath = `/api/v1/patients/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자에게 카카오 알림톡 전송, 이 시점에는 환자 정보 저장 안함
         * @summary Patient 생성 및 동의 알림톡 전송
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPatientCreationLink: async (patientCreateRequest: PatientCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientCreateRequest' is not null or undefined
            assertParamExists('sendPatientCreationLink', 'patientCreateRequest', patientCreateRequest)
            const localVarPath = `/api/v1/patients/send-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patient ID에 해당하는 환자 정보를 부분 수정합니다. 요청 바디에 포함된 값만 반영됩니다.
         * @summary Patient 수정
         * @param {string} patientId 
         * @param {PatientUpdateRequest} patientUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (patientId: string, patientUpdateRequest: PatientUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('update', 'patientId', patientId)
            // verify required parameter 'patientUpdateRequest' is not null or undefined
            assertParamExists('update', 'patientUpdateRequest', patientUpdateRequest)
            const localVarPath = `/api/v1/patients/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientControllerApi - functional programming interface
 * @export
 */
export const PatientControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Patient ID에 해당하는 환자를 soft delete 처리합니다.
         * @summary Patient 삭제
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary QR Code 를 통한 환자 생성, 토큰 없음
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFromBody(code: string, patientCreateRequest: PatientCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFromBody(code, patientCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.createFromBody']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환자 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFromToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFromToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.createFromToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 같은 기관 내에 동일한 환자 코드 또는 전화번호가 이미 존재하는지 확인합니다. code 또는 phoneNumber 중 하나 이상이 필요합니다.
         * @summary Patient 중복 검사
         * @param {string} [code] 
         * @param {string} [phoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exist(code?: string, phoneNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exist(code, phoneNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.exist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patient 다건 조회
         * @param {Array<string>} [ids] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll1(ids?: Array<string>, orgIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Patient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll1(ids, orgIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.findAll1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patient ID로 환자 한 명의 상세 정보를 조회합니다.
         * @summary Patient 단건 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.findById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자 대면 자격(동의 요청·설문 세션·수면일지·신원 토큰)으로 자기 정보를 조회합니다. 삭제된 환자는 404 입니다. 이 경로는 자격이 가리키는 환자를 돌려주므로, 환자를 가리키지 않는 자격(서버 간 호출·업무 사용자)은 인가 거부가 아니라 잘못된 요청(400)입니다.
         * @summary 특정 병원의 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatient(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatient(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 병원 환자 목록 조회
         * @param {string} [searchKeyword] 검색 키워드. null 이면 전체를 반환. 키워드가 있다면 이름과 전화번호에서 검색
         * @param {number} [pageSize] 
         * @param {string} [pageTargetPatientId] null인 경우 가장 최근 부터, 아닌 경우 patientId 이후 부터 검색
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPages(searchKeyword?: string, pageSize?: number, pageTargetPatientId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPages(searchKeyword, pageSize, pageTargetPatientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.getPatientPages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자에게 알림톡 링크로 전달할 신원 토큰을 발행합니다. 수신 서비스(audience)는 지정한 값이 그대로 실리며, 비어 있거나 빈 문자열 원소가 섞이면 400 입니다. 만료(expiresAt)를 생략하면 만료 없는 토큰이 나가고, 이미 지난 시각이면 400 입니다. 없거나 삭제된 환자는 실패시키지 않고 skipped 로 돌려줍니다.
         * @summary 환자 신원 토큰 발행(1건도 목록으로)
         * @param {PatientTokensRequest} patientTokensRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issuePatientTokens(patientTokensRequest: PatientTokensRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientTokens>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issuePatientTokens(patientTokensRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.issuePatientTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 조회 조건을 본문으로 받습니다. 삭제된 환자는 결과에서 빠지고, 없는 ID 는 건너뜁니다.
         * @summary Patient 다건 조회(조건을 본문으로, 삭제된 환자 제외)
         * @param {PatientSearchRequest} patientSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPatients(patientSearchRequest: PatientSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Patient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPatients(patientSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.searchPatients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자에게 카카오 알림톡 전송, 이 시점에는 환자 정보 저장 안함
         * @summary Patient 생성 및 동의 알림톡 전송
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPatientCreationLink(patientCreateRequest: PatientCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPatientCreationLink(patientCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.sendPatientCreationLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patient ID에 해당하는 환자 정보를 부분 수정합니다. 요청 바디에 포함된 값만 반영됩니다.
         * @summary Patient 수정
         * @param {string} patientId 
         * @param {PatientUpdateRequest} patientUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(patientId: string, patientUpdateRequest: PatientUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Patient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(patientId, patientUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientControllerApi - factory interface
 * @export
 */
export const PatientControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientControllerApiFp(configuration)
    return {
        /**
         * Patient ID에 해당하는 환자를 soft delete 처리합니다.
         * @summary Patient 삭제
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(patientId: string, options?: any): AxiosPromise<Patient> {
            return localVarFp._delete(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary QR Code 를 통한 환자 생성, 토큰 없음
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromBody(code: string, patientCreateRequest: PatientCreateRequest, options?: any): AxiosPromise<Patient> {
            return localVarFp.createFromBody(code, patientCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환자 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromToken(options?: any): AxiosPromise<Patient> {
            return localVarFp.createFromToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 같은 기관 내에 동일한 환자 코드 또는 전화번호가 이미 존재하는지 확인합니다. code 또는 phoneNumber 중 하나 이상이 필요합니다.
         * @summary Patient 중복 검사
         * @param {string} [code] 
         * @param {string} [phoneNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exist(code?: string, phoneNumber?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.exist(code, phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patient 다건 조회
         * @param {Array<string>} [ids] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll1(ids?: Array<string>, orgIds?: Array<number>, options?: any): AxiosPromise<Array<Patient>> {
            return localVarFp.findAll1(ids, orgIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Patient ID로 환자 한 명의 상세 정보를 조회합니다.
         * @summary Patient 단건 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById(patientId: string, options?: any): AxiosPromise<Patient> {
            return localVarFp.findById(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자 대면 자격(동의 요청·설문 세션·수면일지·신원 토큰)으로 자기 정보를 조회합니다. 삭제된 환자는 404 입니다. 이 경로는 자격이 가리키는 환자를 돌려주므로, 환자를 가리키지 않는 자격(서버 간 호출·업무 사용자)은 인가 거부가 아니라 잘못된 요청(400)입니다.
         * @summary 특정 병원의 내 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient(options?: any): AxiosPromise<Patient> {
            return localVarFp.getPatient(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 병원 환자 목록 조회
         * @param {string} [searchKeyword] 검색 키워드. null 이면 전체를 반환. 키워드가 있다면 이름과 전화번호에서 검색
         * @param {number} [pageSize] 
         * @param {string} [pageTargetPatientId] null인 경우 가장 최근 부터, 아닌 경우 patientId 이후 부터 검색
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPages(searchKeyword?: string, pageSize?: number, pageTargetPatientId?: string, options?: any): AxiosPromise<PatientPage> {
            return localVarFp.getPatientPages(searchKeyword, pageSize, pageTargetPatientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자에게 알림톡 링크로 전달할 신원 토큰을 발행합니다. 수신 서비스(audience)는 지정한 값이 그대로 실리며, 비어 있거나 빈 문자열 원소가 섞이면 400 입니다. 만료(expiresAt)를 생략하면 만료 없는 토큰이 나가고, 이미 지난 시각이면 400 입니다. 없거나 삭제된 환자는 실패시키지 않고 skipped 로 돌려줍니다.
         * @summary 환자 신원 토큰 발행(1건도 목록으로)
         * @param {PatientTokensRequest} patientTokensRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuePatientTokens(patientTokensRequest: PatientTokensRequest, options?: any): AxiosPromise<PatientTokens> {
            return localVarFp.issuePatientTokens(patientTokensRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 조회 조건을 본문으로 받습니다. 삭제된 환자는 결과에서 빠지고, 없는 ID 는 건너뜁니다.
         * @summary Patient 다건 조회(조건을 본문으로, 삭제된 환자 제외)
         * @param {PatientSearchRequest} patientSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPatients(patientSearchRequest: PatientSearchRequest, options?: any): AxiosPromise<Array<Patient>> {
            return localVarFp.searchPatients(patientSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자에게 카카오 알림톡 전송, 이 시점에는 환자 정보 저장 안함
         * @summary Patient 생성 및 동의 알림톡 전송
         * @param {PatientCreateRequest} patientCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPatientCreationLink(patientCreateRequest: PatientCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendPatientCreationLink(patientCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patient ID에 해당하는 환자 정보를 부분 수정합니다. 요청 바디에 포함된 값만 반영됩니다.
         * @summary Patient 수정
         * @param {string} patientId 
         * @param {PatientUpdateRequest} patientUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(patientId: string, patientUpdateRequest: PatientUpdateRequest, options?: any): AxiosPromise<Patient> {
            return localVarFp.update(patientId, patientUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientControllerApi - object-oriented interface
 * @export
 * @class PatientControllerApi
 * @extends {BaseAPI}
 */
export class PatientControllerApi extends BaseAPI {
    /**
     * Patient ID에 해당하는 환자를 soft delete 처리합니다.
     * @summary Patient 삭제
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public _delete(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration)._delete(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary QR Code 를 통한 환자 생성, 토큰 없음
     * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
     * @param {PatientCreateRequest} patientCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public createFromBody(code: string, patientCreateRequest: PatientCreateRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).createFromBody(code, patientCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환자 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public createFromToken(options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).createFromToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 같은 기관 내에 동일한 환자 코드 또는 전화번호가 이미 존재하는지 확인합니다. code 또는 phoneNumber 중 하나 이상이 필요합니다.
     * @summary Patient 중복 검사
     * @param {string} [code] 
     * @param {string} [phoneNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public exist(code?: string, phoneNumber?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).exist(code, phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patient 다건 조회
     * @param {Array<string>} [ids] 
     * @param {Array<number>} [orgIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public findAll1(ids?: Array<string>, orgIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).findAll1(ids, orgIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patient ID로 환자 한 명의 상세 정보를 조회합니다.
     * @summary Patient 단건 조회
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public findById(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).findById(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자 대면 자격(동의 요청·설문 세션·수면일지·신원 토큰)으로 자기 정보를 조회합니다. 삭제된 환자는 404 입니다. 이 경로는 자격이 가리키는 환자를 돌려주므로, 환자를 가리키지 않는 자격(서버 간 호출·업무 사용자)은 인가 거부가 아니라 잘못된 요청(400)입니다.
     * @summary 특정 병원의 내 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatient(options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatient(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 병원 환자 목록 조회
     * @param {string} [searchKeyword] 검색 키워드. null 이면 전체를 반환. 키워드가 있다면 이름과 전화번호에서 검색
     * @param {number} [pageSize] 
     * @param {string} [pageTargetPatientId] null인 경우 가장 최근 부터, 아닌 경우 patientId 이후 부터 검색
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public getPatientPages(searchKeyword?: string, pageSize?: number, pageTargetPatientId?: string, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).getPatientPages(searchKeyword, pageSize, pageTargetPatientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자에게 알림톡 링크로 전달할 신원 토큰을 발행합니다. 수신 서비스(audience)는 지정한 값이 그대로 실리며, 비어 있거나 빈 문자열 원소가 섞이면 400 입니다. 만료(expiresAt)를 생략하면 만료 없는 토큰이 나가고, 이미 지난 시각이면 400 입니다. 없거나 삭제된 환자는 실패시키지 않고 skipped 로 돌려줍니다.
     * @summary 환자 신원 토큰 발행(1건도 목록으로)
     * @param {PatientTokensRequest} patientTokensRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public issuePatientTokens(patientTokensRequest: PatientTokensRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).issuePatientTokens(patientTokensRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 조회 조건을 본문으로 받습니다. 삭제된 환자는 결과에서 빠지고, 없는 ID 는 건너뜁니다.
     * @summary Patient 다건 조회(조건을 본문으로, 삭제된 환자 제외)
     * @param {PatientSearchRequest} patientSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public searchPatients(patientSearchRequest: PatientSearchRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).searchPatients(patientSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자에게 카카오 알림톡 전송, 이 시점에는 환자 정보 저장 안함
     * @summary Patient 생성 및 동의 알림톡 전송
     * @param {PatientCreateRequest} patientCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public sendPatientCreationLink(patientCreateRequest: PatientCreateRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).sendPatientCreationLink(patientCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patient ID에 해당하는 환자 정보를 부분 수정합니다. 요청 바디에 포함된 값만 반영됩니다.
     * @summary Patient 수정
     * @param {string} patientId 
     * @param {PatientUpdateRequest} patientUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientControllerApi
     */
    public update(patientId: string, patientUpdateRequest: PatientUpdateRequest, options?: RawAxiosRequestConfig) {
        return PatientControllerApiFp(this.configuration).update(patientId, patientUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

